import { ApiError } from './api/api';
import { isAxiosError } from 'axios';
import { toast } from 'react-toastify';
import AlertIcon from '../assets/svg/newSvg/alert.svg?react';
import '~/assets/css/toastify.css';
import i18next from 'i18next';

export function useToastError() {
  return (error?: unknown, shouldShowText?: boolean) => {
    const t = i18next.t;
    let message = '';
    let status;

    if (typeof error === 'string') {
      message = error;
    } else if (!(error instanceof ApiError)) {
      message = t('unknown_error');
      if (isAxiosError(error)) {
        try {
          if (error.response?.data?.message) {
            message = error.response.data.message;
          } else {
            message = error.response!.data[0].errors[0];
          }
        } catch (e) {}
      }
    } else {
      message = error?.message;
      status = error.code;
    }

    shouldShowText = shouldShowText === undefined ? true : shouldShowText;

    return toast(
      <div className="toastContent">
        <span className="toastContentTitle">{message}</span>
        {shouldShowText && (
          <span className="toastContentText">
            {status === 401 ? t('login_error') : t('try_again')}
          </span>
        )}
      </div>,
      {
        type: 'error',
        position: 'top-right',
        autoClose: 5000,
        draggable: true,
        closeOnClick: true,
        pauseOnHover: true,
        className: 'toastError',
        icon: <AlertIcon />,
      }
    );
  };
}
